/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ExternalMCPHeaderDefinition,
  ExternalMCPHeaderDefinition$inboundSchema,
} from "./externalmcpheaderdefinition.js";
import {
  FunctionEnvironmentVariable,
  FunctionEnvironmentVariable$inboundSchema,
} from "./functionenvironmentvariable.js";
import {
  InstanceMcpServer,
  InstanceMcpServer$inboundSchema,
} from "./instancemcpserver.js";
import {
  PromptTemplate,
  PromptTemplate$inboundSchema,
} from "./prompttemplate.js";
import {
  SecurityVariable,
  SecurityVariable$inboundSchema,
} from "./securityvariable.js";
import {
  ServerVariable,
  ServerVariable$inboundSchema,
} from "./servervariable.js";
import { Tool, Tool$inboundSchema } from "./tool.js";

export type GetInstanceResult = {
  /**
   * The description of the toolset
   */
  description?: string | undefined;
  /**
   * The external MCP header definitions that are relevant to the toolset
   */
  externalMcpHeaderDefinitions?: Array<ExternalMCPHeaderDefinition> | undefined;
  /**
   * The function environment variables that are relevant to the toolset
   */
  functionEnvironmentVariables?: Array<FunctionEnvironmentVariable> | undefined;
  /**
   * The MCP servers that are relevant to the toolset
   */
  mcpServers: Array<InstanceMcpServer>;
  /**
   * The name of the toolset
   */
  name: string;
  /**
   * The list of prompt templates
   */
  promptTemplates?: Array<PromptTemplate> | undefined;
  /**
   * The security variables that are relevant to the toolset
   */
  securityVariables?: Array<SecurityVariable> | undefined;
  /**
   * The server variables that are relevant to the toolset
   */
  serverVariables?: Array<ServerVariable> | undefined;
  /**
   * The list of tools
   */
  tools: Array<Tool>;
};

/** @internal */
export const GetInstanceResult$inboundSchema: z.ZodMiniType<
  GetInstanceResult,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    external_mcp_header_definitions: z.optional(
      z.array(ExternalMCPHeaderDefinition$inboundSchema),
    ),
    function_environment_variables: z.optional(
      z.array(FunctionEnvironmentVariable$inboundSchema),
    ),
    mcp_servers: z.array(InstanceMcpServer$inboundSchema),
    name: z.string(),
    prompt_templates: z.optional(z.array(PromptTemplate$inboundSchema)),
    security_variables: z.optional(z.array(SecurityVariable$inboundSchema)),
    server_variables: z.optional(z.array(ServerVariable$inboundSchema)),
    tools: z.array(Tool$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "external_mcp_header_definitions": "externalMcpHeaderDefinitions",
      "function_environment_variables": "functionEnvironmentVariables",
      "mcp_servers": "mcpServers",
      "prompt_templates": "promptTemplates",
      "security_variables": "securityVariables",
      "server_variables": "serverVariables",
    });
  }),
);

export function getInstanceResultFromJSON(
  jsonString: string,
): SafeParseResult<GetInstanceResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetInstanceResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetInstanceResult' from JSON`,
  );
}
